import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
} from "@mui/material";
import { useParams, Link } from "react-router-dom";
import dayjs from "dayjs";
import useEncryption from "../../../services/useEncryption";
import { getTransactionAPIData } from "../../../api/cardApi";

export const TransactionInfoDialog = ({ open, onClose, id }) => {
  const { encryptData, decryptData } = useEncryption();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const decryptedId = decryptData(decodeURIComponent(id));

  useEffect(() => {
    const getTransactionData = async () => {
      try {
        setLoading(true);
        let response = await getTransactionAPIData(decryptedId);
        const decryptedData = decryptData(response?.data?.data);
        // console.log("data", decryptedData)
        setData(decryptedData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching trans data", error);
        setLoading(false);
      }
    };
    getTransactionData();
  }, [decryptedId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Transaction Details
      </DialogTitle>
      <DialogContent>
        <div className='tableDesigned'>
          <Box>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>LocationName</TableCell>
                    <TableCell>Payment Id</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No data found
                      </TableCell>
                    </TableRow>
                  ) : (
                    data.map((row) => (
                      <TableRow key={row._id}>
                        <TableCell>{dayjs(row.paymentCreated * 1000).format("YYYY-MM-DD")}</TableCell>
                        <TableCell>{row.providerId?.organizationName}</TableCell>
                        <TableCell>{row.payment_id}</TableCell>
                        <TableCell>{row.providerId?.email}</TableCell>
                        <TableCell>${row.amount}</TableCell>
                        <TableCell>{row.status}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
